import * as Request from "common/utils/serverRequest";
import DateHelper from "common/utils/DateHelper";
import { notifier } from "common/notifier";
import moment from "moment";
//e.g. use    dataToAdd = "?" + encodeData(data);
export function encodeData(data) {
    return Object.keys(data).map(function (key) {
        return [key, data[key]].map(encodeURIComponent).join("=");
    }).join("&");
}
export const convertDates = (fromDate, toDate) => {
    // Get the dates as strings
    if (!fromDate || !toDate) {
        fromDate = DateHelper.getFirstOfLastMonth();
        toDate = DateHelper.getLastOfLastMonth();
    }
    //console.log(toDate, toDate.format("DD MMMM YYYY hh:mm:ss"));
    // Return the dates as strings
    //return [fromDate.format("DD MMMM YYYY hh:mm:ss"), toDate.format("DD MMMM YYYY hh:mm:ss")];
    return [fromDate.format("DD MMMM YYYY hh:mm:ss a"), toDate.format("DD MMMM YYYY hh:mm:ss a")];
};
export const convertFromServerDates = (date) => {
    //-- Transform the recieved dates to the correct format
    let dateAsString = moment(date, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY");
    return moment(dateAsString, "DD-MM-YYYY");
};
export function handleResponseFailure(error) {
    if (error.status != Request.ResponseStatus.noContent) {
        notifier.notifyError("Error", error.message);
    }
    return Promise.reject(error.message);
}
